import { useRecoilState } from 'recoil';

import {
    authState,
    addressesState,
} from 'store/state';
import { useAddressesActions } from 'services';
import { webLibSdk } from 'helpers';
import { useModal } from 'hooks';

import toastAlert from 'components/UI/Alert';

import {
    METAMASK,
    WALLET_CONNECT,
} from '_constants/loginTypes';
import { NO_METAMASK_MODAL } from '_constants/modalTypes';

const useAuthActions = () => {
    const [, setAuth] = useRecoilState(authState);
    const [addresses, setAddresses] = useRecoilState(addressesState);
    const { getAddresses } = useAddressesActions();
    const { onOpen: onOpenModal } = useModal();

    const logout = async () => {
        await webLibSdk.disconnect();
        setAuth(null);
        setAddresses({ ...addresses, current: '' });
        window.localStorage.removeItem('auth');

        console.log('logout');
    };

    const wrongNetworkWarning = async (err) => {
        toastAlert({
            type: 'error',
            message: err,
        });
        logout();
    };

    const login = async (isMetamask) => {
        try {
            const isMetamaskAvailable = await webLibSdk.isMetamaskAvailable();
            if (isMetamask && !isMetamaskAvailable) {
                onOpenModal(NO_METAMASK_MODAL);
            }

            await webLibSdk[
                isMetamask ? 'connectWithMetamask' : 'connectWithWalletConnect'
            ](wrongNetworkWarning, logout);
            const isConnected = await webLibSdk.isConnected();

            if (isConnected) {
                const { current: currentAddress } = await getAddresses();

                const userData = {
                    loggedInWith: isMetamask ? METAMASK : WALLET_CONNECT,
                    currentAddress,
                };
                setAuth(userData);
                window.localStorage.setItem('auth', JSON.stringify(userData));
            }
        } catch (err) {
            console.error('Error in auth service, login:', err);

            if (err.type === 'network') {
                wrongNetworkWarning(err.message);
                return;
            }
            logout();

            throw err;
        }
    };

    return {
        login,
        logout,
    };
};

export default useAuthActions;
